import { Query } from '../../_base/actionBus/Query';

export class GetRedepagosBarcode extends Query<string> {}
